import script from "./mentor_request_career.vue?vue&type=script&setup=true&lang=ts"
export * from "./mentor_request_career.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__